export const calculateTxCreditTotalAmount = (maxAmount: number, availableAmount: number): number => {
    return maxAmount + availableAmount
}
